import React from 'react';

const FileLoader = () => <div className="lds-dual-ring"></div>;

export default FileLoader;
